import { Skeleton, Stack} from "@mui/material"
import { BoxPanel } from "screens/styles";

export const QuestionFreeTextSkeleton = () => {
    return (
        <BoxPanel className="BoxShadow" >
            <Stack gap={6} paddingBottom={3}>
                <Stack direction={'row'} justifyContent='space-between' alignItems={'center'}>
                    <Stack gap={2} width={'100%'}>
                        <Skeleton variant='text' sx={{borderRadius:8, width:'32%', backgroundColor:'#E9ECF5'}}/>
                        <Skeleton variant='text' sx={{borderRadius:8, width:'64%', backgroundColor:'#E9ECF5'}}/>
                    </Stack>
                    <Skeleton variant='rectangular' sx={{borderRadius:8,  width:'17%', height:33, backgroundColor:'#E9ECF5'}}/>
                </Stack>
                <Skeleton variant='rectangular' width={'100%'} className="BoxShadow" sx={{borderRadius:8, height:48, backgroundColor:'#E9ECF5'}}/>
            </Stack>
        </BoxPanel>
    )
}
